export enum autocompleteStates {
    NO_DATA_RECENTS = -3,
    NO_DATA_SIMILARSITES,
    NO_DATA_SIMILARAPPS = -2,
    NO_DATA_SEARCHES = -1,
    LOADING = 1,
    ERROR = 2,
}
